import { STATUS_TYPE } from '../../../enum';

export interface CreateChangeAdvertiseMediaPosition {
  advertiseId: string;
  attachmentArray: string[];
}

export interface ChangeAdvertiseMediaPosition {
  id: string;
  advertiseId: string;
  attachmentArray: string[];
  createdBy: string;
  updatedBy: string;
  updatedAt: string;
  createdAt: string;
}

interface InitialState {
  data: ChangeAdvertiseMediaPosition[];
  skip: number;
  limit: number;
  totalRecords: number;
  currentPage: number;
  status: STATUS_TYPE;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  errorMessage: string;
}

export const initialState: InitialState = {
  data: [],
  skip: 0,
  limit: 25,
  totalRecords: 0,
  currentPage: 0,
  status: 'idle',
  isError: false,
  isLoading: false,
  isSuccess: false,
  errorMessage: '',
};
